import PropTypes from 'prop-types'
import { LeaderboardPageWithData } from '@layouts/leaderboard/index'

function LeaderboardPage(props) {
  return <LeaderboardPageWithData {...props} />
}

LeaderboardPage.getInitialProps = async ({ query }) => ({ query })

LeaderboardPage.propTypes = {
  query: PropTypes.object,
}

export default LeaderboardPage
